export const getLocalizedLabel = (
  displayNameEn: string,
  displayNameDe: string | null | undefined,
  currentLanguage: string,
) => {
  return currentLanguage === "DE" && displayNameDe
    ? displayNameDe
    : displayNameEn
}
